(() => {
  const storefrontOrigin = window.location.origin;
  const localeRootWithSlash = window.Shopify?.routes?.root || '/';
  const localeRoot = localeRootWithSlash === '/' ? '/' : localeRootWithSlash.replace(/\/$/, '');
  const localePrefixes = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'))
    .map((link) => link.getAttribute('hreflang'))
    .filter((code) => code && code.toLowerCase() !== 'x-default')
    .map((code) => `/${code.toLowerCase()}`);

  if (localeRoot !== '/') localePrefixes.push(localeRoot.toLowerCase());

  const uniqueLocalePrefixes = [...new Set(localePrefixes)].sort((left, right) => right.length - left.length);
  const excludedPaths = [
    '/admin',
    '/cdn/',
    '/challenge',
    '/customer_authentication/',
    '/localization',
    '/payments',
    '/services/login_with_shop',
    '/wallets',
    '/.well-known/',
  ];

  const hasLocalePrefix = (path, prefix) =>
    path.toLowerCase() === prefix || path.toLowerCase().startsWith(`${prefix}/`);

  const isExcludedPath = (path) =>
    excludedPaths.some((excludedPath) =>
      excludedPath.endsWith('/') ? path.startsWith(excludedPath) : path === excludedPath || path.startsWith(`${excludedPath}/`)
    );

  const normalizeUrl = (rawUrl) => {
    if (!rawUrl || /^(#|mailto:|tel:|sms:|javascript:|data:|blob:)/i.test(rawUrl)) return rawUrl;

    let parsedUrl;
    try {
      parsedUrl = new URL(rawUrl, window.location.href);
    } catch (_error) {
      return rawUrl;
    }

    if (parsedUrl.origin !== storefrontOrigin || isExcludedPath(parsedUrl.pathname)) return rawUrl;

    let basePath = parsedUrl.pathname;
    const existingPrefix = uniqueLocalePrefixes.find((prefix) => hasLocalePrefix(basePath, prefix));
    if (existingPrefix) basePath = basePath.slice(existingPrefix.length) || '/';

    const localizedPath = localeRoot === '/'
      ? basePath
      : basePath === '/'
        ? localeRoot
        : `${localeRoot}${basePath}`;

    return `${localizedPath}${parsedUrl.search}${parsedUrl.hash}`;
  };

  const shouldSkipElement = (element) =>
    element.hasAttribute('hreflang') ||
    Boolean(element.closest('[data-ke-locale-switch], form[action*="/localization"]'));

  const normalizeElement = (element) => {
    if (shouldSkipElement(element)) return;

    const attribute = element.matches('form[action]') ? 'action' : 'href';
    const currentValue = element.getAttribute(attribute);
    const normalizedValue = normalizeUrl(currentValue);
    if (normalizedValue && normalizedValue !== currentValue) element.setAttribute(attribute, normalizedValue);
  };

  const normalizeTree = (root) => {
    if (root.nodeType === 1 && root.matches('a[href], area[href], form[action]')) normalizeElement(root);
    root.querySelectorAll?.('a[href], area[href], form[action]').forEach(normalizeElement);
  };

  const initialize = () => {
    normalizeTree(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          normalizeElement(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) normalizeTree(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href', 'action'],
    });
  };

  window.KabluchkaLocaleLinks = Object.freeze({ normalizeUrl });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
